import {AddrDetailApiResponse} from '@dms/api/core';

import {ApiEnumItem} from '../../../types/ApiEnum';
import {AuctionTypeFilter} from '../../../types/AuctionTypeFilter';
import {CarStatusFilter} from './CarStatusFilter';
import {VehicleCategoryFilter} from './VehicleCategoryFilter';

export type FiltersType = {
  address?: AddrDetailApiResponse | null;
  radius?: number | null;
  sellerCountry?: string[];
  sellerServer?: string[];
  sellerType?: string[];
  /** Country the vehicle originally comes from (Alpha-3), not the seller country */
  originCountry?: string[];
  /** Passenger cars / vans; `null` or `undefined` = all categories */
  vehicleCategory?: VehicleCategoryFilter | null;
  make?: string[];
  model?: string[];
  fuelType?: string[];
  transmission?: string[];
  bodyType?: string[];
  /** Van body length classes; only used for vans on classifieds */
  vehicleLengthCategory?: string[];
  /** Van body height classes; only used for vans on classifieds */
  vehicleHeightCategory?: string[];
  doorCount?: string[];
  drive?: string[];
  selectedColors?: ApiEnumItem[];
  interiorMaterial?: string[];
  reclaimableVat?: boolean;
  hideSuspicious: boolean;
  excludeSuspiciousReasons?: string[];
  hitlistOnly?: boolean;
  hideBlacklist?: boolean;
  features?: string[];
  adTitle?: string | null;
  trimLevels?: string[];

  // sliders
  mileageRange?: [number, number];
  power?: [number, number];
  cubicCapacity?: [number, number];
  margin?: [number, number];
  marginPercent?: [number, number];
  priceCZK?: [number, number];
  /** Missing means the legacy 4,000,000 unbounded-price sentinel. */
  priceRangeVersion?: 2;
  liquidity?: [number, number];
  pricePosition?: [number, number];
  daysOnDisplay?: [number, number];
  year?: [number, number];
  numberOfSeats?: [number, number];
  avgNumberAds?: [number, number];
  featureScore?: [number, number];

  // helpers
  isMarginAbsolute: boolean;
  isPowerInKW: boolean;

  // auction-specific filters
  auctionType?: AuctionTypeFilter[];
  carStatus?: CarStatusFilter[];
  auctionServer?: string[];
};

export const DEFAULT_FILTERS: FiltersType = {
  isMarginAbsolute: true,
  isPowerInKW: true,
  hideSuspicious: false,
};
